
export const authReducer = (auth) => (state = auth, {type, payload}) => {
  return state;
}
